import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { onUpdateAvailable, applyUpdate } from "@/lib/pwa";

/**
 * Yeni sürüm hazır bildirimi — sağ altta zarif altın pill.
 * SW controller change'i tetiklediğinde sayfa otomatik reload olur.
 * Kullanıcı bir kez "sonra" derse localStorage'a düşer, ama SW yeni versiyon
 * yaydığında yine görünür (her yeni versiyona bir kez sorar).
 */
export default function UpdatePrompt() {
  const [visible, setVisible] = useState(false);
  const [applying, setApplying] = useState(false);

  useEffect(() => {
    const unsub = onUpdateAvailable(({ available }) => {
      if (available) setVisible(true);
    });
    return unsub;
  }, []);

  if (!visible) return null;

  const handle = () => {
    setApplying(true);
    applyUpdate();
  };

  return (
    <div
      className="fixed z-[100] pointer-events-none flex justify-center"
      style={{
        left: 0,
        right: 0,
        bottom: "max(1rem, env(safe-area-inset-bottom))",
      }}
      data-testid="update-prompt"
    >
      <div
        className="pointer-events-auto flex items-center gap-3 pl-4 pr-2 py-2 backdrop-blur-xl border shadow-[0_20px_50px_-12px_rgba(212,175,55,0.55)]"
        style={{
          background: "linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)",
          borderColor: "rgba(212,175,55,0.5)",
          borderRadius: "999px",
        }}
      >
        <span
          className="relative flex h-2 w-2"
          aria-hidden
        >
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-70" style={{ background: "var(--gold)" }} />
          <span className="relative inline-flex rounded-full h-2 w-2" style={{ background: "var(--gold)" }} />
        </span>
        <span className="text-xs sm:text-sm text-white/90">
          Yeni sürüm hazır
        </span>
        <button
          onClick={handle}
          disabled={applying}
          data-testid="update-prompt-apply"
          className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-mono tracking-widest uppercase transition-all active:scale-95 disabled:opacity-60"
          style={{
            background: "var(--gold)",
            color: "#0a0a0a",
            borderRadius: "999px",
          }}
        >
          <RefreshCw size={12} className={applying ? "animate-spin" : ""} />
          {applying ? "Yenileniyor" : "Güncelle"}
        </button>
        <button
          onClick={() => setVisible(false)}
          data-testid="update-prompt-dismiss"
          className="w-7 h-7 flex items-center justify-center text-neutral-500 hover:text-white transition"
          aria-label="Sonra"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
